import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { NodeComments } from '../model/node-comments.model';

@Injectable({
    providedIn: 'root'
})
export class CommentsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    createComment(newComment: any) {
        return this.post<any>(EndPoints.comments_Create, false, '', {
            newComment: newComment
        });
    }

    editComment(editComment: any): Observable<any> {
        return this.post<any>(EndPoints.comments_Update, false, '', {
            editComment: editComment
        });
    }

    deleteComment(deleteComment: any): Observable<any> {
        return this.post<any>(EndPoints.comments_Delete, false, '', {
            deleteComment: deleteComment
        });
    }
}
